// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"352":"system-administrator","487":"privileges","806":"user","905":"tenant-management","933":"auth"}[chunkId] || chunkId) + "." + {"61":"a7e3e404","352":"70fb6c05","487":"314f442b","623":"7c747cab","806":"74265019","905":"92163a32","933":"64341b55"}[chunkId] + ".js";
};